import { Stack, IconButton, useTheme } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SeoHelmet from "../../Components/SeoHelmet";
import { useDispatch } from "react-redux";
import { useGetPagesSeoApiQuery } from "../../Store/Slices/rtk";
import AnalyticsTracker from "../../Components/AnalyticsTracker";
import LightRays from "../../Components/LightRays";

export default function MainLayout() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const doNotFetchPaths = [
    "product-details",
    "category-details",
    "brand-details",
    "blog-details",
    "course-details",
  ];

  const location = useLocation().pathname;
  const {
    data: seoData,
    isSuccess,
    isLoading,
  } = useGetPagesSeoApiQuery(
    {
      route: location,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: doNotFetchPaths?.includes(pathname?.split("/")?.at(1)),
    },
  );

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollTop();
  }, [pathname]);

  // SEO Configurations
  const seo = isSuccess && !isLoading ? seoData?.data : null;
  const defaultTitle = "نی موبایل | مرجع فروش موبایل و لوازم جانبی";
  const defaultDesc =
    "نی موبایل مرجع تخصصی خرید موبایل، ساعت هوشمند، هندزفری و لوازم جانبی با بهترین قیمت.";
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <>
      <AnalyticsTracker />
      <SeoHelmet
        title={defaultTitle}
        metaTitle={seo?.meta_title || defaultTitle}
        metaKeywords={
          seo?.meta_keywords ||
          "بهترین قیمت موبایل و جدیدترین گجت‌ها - ارسال سریع"
        }
        metaDescription={seo?.meta_description || defaultDesc}
        index={seo?.index !== undefined ? seo.index : true}
        follow={seo?.follow !== undefined ? seo.follow : true}
        ogTitle={seo?.og_title || seo?.meta_title || defaultTitle}
        ogDescription={
          seo?.og_description || seo?.meta_description || defaultDesc
        }
        ogType={seo?.og_type || "website"}
        ogUrl={seo?.og_url || currentUrl}
        ogImage={
          seo?.og_image?.file_name
            ? `${import.meta.env.VITE_URL}${seo.og_image.file_name}`
            : undefined
        }
        twitterTitle={
          seo?.twitter?.twitter_title || seo?.meta_title || defaultTitle
        }
        twitterDescription={
          seo?.twitter?.twitter_description ||
          seo?.meta_description ||
          defaultDesc
        }
        twitterCard={seo?.twitter?.twitter_card || "summary_large_image"}
        scheme={seo?.json_schema}
      />
      <Stack sx={{ minHeight: "100vh", position: "relative" }}>
        <Navbar />
        <Stack sx={{ width: "100%", overflow: "visible", pb: "3rem" }}>
          <Outlet />
        </Stack>
        <Stack sx={{ width: "100%", overflow: "hidden" }}>
          <Footer />
        </Stack>

        <IconButton
          onClick={scrollTop}
          aria-label="scroll-top-button"
          sx={{
            position: "fixed",
            bottom: "2rem",
            zIndex: "1000000",
            left: "2rem",
            width: "55px",
            height: "55px",
            borderRadius: "50%",
            border: `2px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            background: theme.palette.background.default,
            boxShadow: `0 2px 12px ${theme.palette.primary.main}40`,
            transition: "0.3s",
            "&:hover": {
              background: theme.palette.primary.main,
              color: theme.palette.background.default,
            },
          }}
        >
          <ArrowUpwardIcon sx={{ fontSize: "2rem" }} />
        </IconButton>
      </Stack>
    </>
  );
}
